export default function provinceTripLimits (provinceCode) {
    if(provinceCode === "AB") {return 183;}
    else if(provinceCode === "BC") {return 212;}
    else if(provinceCode === "MB") {return 212;}
    else if(provinceCode === "NB") {return 183;}
    else if(provinceCode === "NL") {return 212;}
    else if(provinceCode === "NS") {return 212;}
    else if(provinceCode === "NT") {return 183;}
    else if(provinceCode === "NU") {return 183;}
    else if(provinceCode === "ON") {return 212;}
    else if(provinceCode === "PE") {return 183;}
    else if(provinceCode === "QC") {return 183;}
    else if(provinceCode === "SK") {return 212;}
    else if(provinceCode === "YT") {return 183;}
    return 212;
}